/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as cartAction from './action/cart.action';
import * as store from '../state.interface';
import {
  GetCartList,
  AddToCart,
  addToCartFailed,
  addToCartLoaded,
  addToCartLoading,
  cartCount,
  cartCountFailed,
  cartCountLoaded,
  cartCountLoading,
  AddToCartValid, deleteFromCartFailed, deleteFromCartLoaded, deleteFromCartLoading, DeleteFromCart
} from './reducer/cart.selector';

@Injectable()
export class CartSandbox {
  /* get cart count status*/
  public cartCount$ = this.appState$.select(cartCount);
  public cartCountLoading$ = this.appState$.select(cartCountLoading);
  public cartCountLoaded$ = this.appState$.select(cartCountLoaded);
  public cartCountFailed$ = this.appState$.select(cartCountFailed);
  /* get addToCart status*/
  public AddToCart$ = this.appState$.select(AddToCart);
  public AddToCartValid$ = this.appState$.select(AddToCartValid);
  public addToCartLoading$ = this.appState$.select(addToCartLoading);
  public addToCartLoaded$ = this.appState$.select(addToCartLoaded);
  public addToCartFailed$ = this.appState$.select(addToCartFailed);
  public deleteFromCart$ = this.appState$.select(DeleteFromCart);
  public deleteFromLoading$ = this.appState$.select(deleteFromCartLoading);
  public deleteFromLoaded$ = this.appState$.select(deleteFromCartLoaded);
  public deleteFromFailed$ = this.appState$.select(deleteFromCartFailed);

  public GetCartListList$ = this.appState$.select(GetCartList);

  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    protected appState$: Store<store.AppState>
  ) {
    this.registerEvents();
  }

  public getCartCounts(params): void {
    this.appState$.dispatch(new cartAction.GetCartCount(params));
  }

  public doAddToCart(params): void {
    this.appState$.dispatch(new cartAction.AddToCart(params));
  }

  public deleteFromCart(params): void {
    this.appState$.dispatch(new cartAction.DeleteFromCart(params));
  }

  public GetCartListList(params) {
    this.appState$.dispatch(new cartAction.GetCartList(params));
  }

  public registerEvents() {}
}
